import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { FC } from 'react';

const GenericEmptyState: FC<{ textContent: string }> = ({ textContent }) => (
  <FuelFlex
    defaultProps={{
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      gap: 'km6',
      customPadding: `0 0 ${DS_TOKENS.spacing.km4}`,
    }}
  >
    <FuelTypography size="body-md" color="neutral-default" weight="medium">
      {textContent}
    </FuelTypography>
  </FuelFlex>
);

export default GenericEmptyState;
